import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./ZipChecker.css";

/** "Do we pick up near you?" — NYC ZIP checker. */

function boroughFor(z: string): string | null {
  const n = parseInt(z, 10);
  if (n >= 10001 && n <= 10282) return "Manhattan";
  if (n >= 10301 && n <= 10314) return "Staten Island";
  if (n >= 10451 && n <= 10475) return "the Bronx";
  if ((n >= 11004 && n <= 11109) || (n >= 11351 && n <= 11697)) return "Queens";
  if (n >= 11201 && n <= 11256) return "Brooklyn";
  return null;
}

const ZipChecker: React.FC<{ compact?: boolean }> = ({ compact }) => {
  const [zip, setZip] = useState("");
  const [result, setResult] = useState<null | { kind: "yes" | "no" | "bad"; borough?: string; zip?: string }>(null);

  const check = () => {
    const raw = zip.trim();
    if (!/^\d{5}$/.test(raw)) { setResult({ kind: "bad" }); return; }
    const borough = boroughFor(raw);
    setResult(borough ? { kind: "yes", borough } : { kind: "no", zip: raw });
  };

  return (
    <div className={`zc-card${compact ? " compact" : ""}`}>
      <span className="zc-eyebrow">🗽 Check your area</span>
      <h3 className="zc-title">Do we pick up near you?</h3>
      <p className="zc-sub">Pop in your ZIP code — we cover all five boroughs of NYC. 💚</p>
      <div className="zc-row">
        <input
          value={zip}
          onChange={(e) => setZip(e.target.value.replace(/\D/g, "").slice(0, 5))}
          onKeyDown={(e) => { if (e.key === "Enter") check(); }}
          inputMode="numeric"
          placeholder="e.g. 11211"
          aria-label="ZIP code"
        />
        <button className="ee-btn ee-btn-green zc-btn" onClick={check} type="button">Check</button>
      </div>
      {result && (
        <div className={`zc-result ${result.kind}`}>
          {result.kind === "yes" && (
            <>
              <strong>🎉 Yes — we've got you!</strong>
              We offer free pickups in <b>{result.borough}</b>. Ready to book?
            </>
          )}
          {result.kind === "no" && (
            <>
              <strong>📍 Not yet — but soon!</strong>
              We're NYC-only for now and growing. Join the newsletter and we'll tell you the moment we
              reach {result.zip}. <Link to="/#newsletter">🔔 Notify me →</Link>
            </>
          )}
          {result.kind === "bad" && (
            <>
              <strong>🤔 Hmm…</strong>
              Please enter a valid 5-digit ZIP code.
            </>
          )}
        </div>
      )}
      <div className="zc-boroughs">
        Serving <b>Brooklyn</b>, <b>Manhattan</b>, <b>Queens</b>, <b>the Bronx</b> &amp; <b>Staten Island</b>.
      </div>
    </div>
  );
};

export default ZipChecker;
